import { Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { OrganizationInviteStatus } from "../../../../autogen/bff-api";

export const InvitedOrganizationStatusTag = ({ status }: { status: OrganizationInviteStatus }) => {
  const { t } = useTranslation();
  const getTagMeta = (status: OrganizationInviteStatus): { color: string; text: string } => {
    switch (status) {
      case OrganizationInviteStatus.BidIsSubmitted:
        return {
          color: "purple",
          text: t("Bid submitted"),
        };
      case OrganizationInviteStatus.BidWasNotNotSubmitted:
        return {
          color: "gray",
          text: t("No bid submitted"),
        };
      case OrganizationInviteStatus.InvitationAccepted:
        return {
          color: "teal",
          text: t("Intends to bid"),
        };
      case OrganizationInviteStatus.InvitationSent:
        return {
          color: "gray",
          text: t("Has not seen event"),
        };
      case OrganizationInviteStatus.HasSeenEvent:
        return {
          color: "orange",
          text: t("Has seen event"),
        };
      case OrganizationInviteStatus.IsLoser:
        return {
          color: "red",
          text: t("Loser"),
        };
      case OrganizationInviteStatus.IsWinner:
        return {
          color: "green",
          text: t("Winner!"),
        };
      case OrganizationInviteStatus.DraftCreated:
        return {
          color: "teal",
          text: t("Draft created"),
        };
      case OrganizationInviteStatus.InvitationDeclined:
        return {
          color: "gray",
          text: t("Invitaion declined"),
        };
    }
  };

  const tagMeta = getTagMeta(status);

  return (
    <Tag colorScheme={tagMeta.color} size="sm" textAlign="center" py="2">
      {tagMeta.text}
    </Tag>
  );
};
